export enum BaccaratCardPosition {
    PlayerFirstCard = 0,
    PlayerSecondCard = 1,
    BankerFirstCard = 2,
    BankerSecondCard = 3,
    PlayerThirdCard = 4,
    BankerThirdCard = 5
}

export enum BaccaratOutcome {
    PlayerWin = 0,
    BankerWin = 1,
    Tie = 2
}

export enum BaccaratSidePosition {
    Banker = 'banker',
    Player = 'player'
}

export interface BaccaratHandValues {
    bankerHandValue: number;
    playerHandValue: number;
}
